export default function PageHeader({ title, subtitle, image }: { title: string; subtitle?: string; image: string }) {
  return (
    <section className="relative w-full h-[360px] md:h-[440px] overflow-hidden">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover object-top" />
      <div className="absolute inset-0 bg-background-950/70"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-10 pt-20">
        <h1 className="font-heading text-white text-3xl md:text-5xl lg:text-6xl font-bold leading-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}